export default [
  {
    path: '/real-estate-developments/:id/accessories/new',
    name: 'RealEstateDevelopmentsAccessoriesCreate',
    component: () => import('pages/real-estate-developments/tabs/accessories/AccessoriesForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/accessories/:id/edit',
    name: 'RealEstateDevelopmentsAccessoriesEdit',
    component: () => import('pages/real-estate-developments/tabs/accessories/AccessoriesForm.vue')
  }
]
